function denormalize( res ) {

	if( !res ){
		return [];
	}
    
    if( !res.results ){
    	return res;
    }

    return res.results.map( id => res.resultsMap[ id ] );
}

export default denormalize;